import { Model, useRepo } from "pinia-orm";

import { BaseModel } from "src/models/Base.js";

import { Location } from "src/models/Location.js";
import { Node, NodeContact } from "src/models/Node.js";
import { Tag } from "src/models/Tag.js";
import { User } from "src/models/User.js";

export class Contact extends Model {
  static fields() {
    return {
      $hash: this.attr({}),
      id: this.uid(),
      created_at: this.attr(null),
      updated_at: this.attr(null),
      createdById: this.attr(null),
      updatedById: this.attr(null),
      created_by: this.belongsTo(User, "createdById"),
      updated_by: this.belongsTo(User, "updatedById"),
      kind: this.string(""),
      is_global: this.boolean(true),
      business_name: this.string(""),
      attention: this.string(""),
      first_name: this.string(""),
      middle_name: this.string(""),
      last_name: this.string(""),
      suffix: this.string(""),
      enable: this.boolean(true),
      enable_marketing: this.boolean(true),
      data: this.attr({}),
      tags: this.belongsToMany(Tag, TagContact, "contactId", "tagId"),
      userId: this.attr(null),
      user: this.belongsTo(User, "userId"),
      /*locations: this.belongsToMany(
        Location,
        LocationContact,
        "contactId",
        "locationId"
      ),*/
      locations: this.hasManyBy(Location, "location_ids"),
      location_ids: this.attr([]),

      node_ids: this.attr([]),
      //nodes: this.hasManyBy(Node, "node_ids"),
      emails: this.belongsToMany(
        ContactEmail,
        ContactEmailContact,
        "contactId",
        "contactEmailId"
      ),
      phones: this.belongsToMany(
        ContactPhone,
        ContactPhoneContact,
        "contactId",
        "contactPhoneId"
      ),
    };
  }
  get pivotMap() {
    return {
      locations: useRepo(LocationContact),
      nodes: useRepo(NodeContact),
      contacts: useRepo(NodeContact),
    };
  }
}
Contact.entity = "contacts";

class TagContact extends Model {
  static fields() {
    return {
      tagId: this.attr(null),
      contactId: this.attr(null),
    };
  }
}
TagContact.entity = "tag_contact";
TagContact.primaryKey = ["tagId", "contactId"];

class ContactEmailContact extends Model {
  static fields() {
    return {
      contactEmailId: this.uid(),
      contactId: this.uid(),
    };
  }
}
ContactEmailContact.entity = "contact_email_contact";
ContactEmailContact.primaryKey = ["contactEmailId", "contactId"];

class ContactPhoneContact extends Model {
  static fields() {
    return {
      contactPhoneId: this.uid(),
      contactId: this.uid(),
    };
  }
}
ContactPhoneContact.entity = "contact_phone_contact";
ContactPhoneContact.primaryKey = ["contactPhoneId", "contactId"];

export class ContactEmail extends BaseModel {
  static fields() {
    return {
      $hash: this.attr(null),
      id: this.uid(),
      created_at: this.attr(null),
      updated_at: this.attr(null),
      createdById: this.attr(null),
      updatedById: this.attr(null),
      created_by: this.belongsTo(User, "createdById"),
      updated_by: this.belongsTo(User, "updatedById"),
      kind: this.string(""),
      email_address: this.string(""),
      enable: this.boolean(true),
      enable_marketing: this.boolean(true),
      is_verified: this.boolean(false),
      is_primary: this.boolean(false),
      contact_ids: this.attr([]),
      contacts: this.hasManyBy(Contact, "contact_ids"),
    };
  }
  /*
  static saving(model) {
    useRepo(ContactEmailContact).save(
      model.contact_ids.map((id) => {
        return { contactEmailId: model.id, contactId: id };
      })
    );
  }
  static deleting(model) {
    useRepo(ContactEmailContact)
      .where((pivot) => model.contact_ids.includes(pivot.contactId))
      .where("contactEmailId", model.id)
      .delete();
  }
  */
  get pivotMap() {
    return {
      contacts: useRepo(ContactEmailContact),
      /*locations: useRepo(ContactLocation),
      nodes: useRepo(ContactNodes),*/
    };
  }
}
ContactEmail.entity = "contact_emails";

export class LocationContact extends Model {
  static fields() {
    return {
      contactId: this.uid(),
      locationId: this.uid(),
    };
  }
}
LocationContact.entity = "contact_location";
LocationContact.primaryKey = ["contactId", "locationId"];

export class ContactPhone extends BaseModel {
  static fields() {
    return {
      $hash: this.attr(null),
      id: this.uid(),
      created_at: this.attr(null),
      updated_at: this.attr(null),
      createdById: this.attr(null),
      updatedById: this.attr(null),
      created_by: this.belongsTo(User, "createdById"),
      updated_by: this.belongsTo(User, "updatedById"),
      kind: this.string(""),
      phone_number: this.string(""),
      enable_sms: this.boolean(true),
      enable_voice: this.boolean(true),
      enable_conference: this.boolean(true),
      enable_marketing: this.boolean(true),
      is_verified: this.boolean(false),
      contact_ids: this.attr([]),
      contacts: this.hasManyBy(Contact, "contact_ids"),
    };
  }
  /*
  static saving(model) {
    useRepo(ContactPhoneContact).save(
      model.contact_ids.map((id) => {
        return { contactPhoneId: model.id, contactId: id };
      })
    );
  }
  static deleting(model) {
    useRepo(ContactPhoneContact)
      .where((pivot) => model.contact_ids.includes(pivot.contactId))
      .where("contactPhoneId", model.id)
      .delete();
  }
  */
  get pivotMap() {
    return {
      contacts: useRepo(ContactPhoneContact),
    };
  }
}
ContactPhone.entity = "contact_phones";
